<template>
  <v-menu
    offset-y
  >
    <v-btn
      slot="activator"
      flat
      icon
      small
      color="info lighten-2"
      class="ma-0"
    >
      <v-icon
        :class="iconClass"
        small
      >help</v-icon>
    </v-btn>
    <div>
      <v-card
        class="light-blue lighten-5"
        @click.stop>
        <v-card-text :style="{width: (width || 400) + 'px'}">
          <slot/>
        </v-card-text>
      </v-card>
    </div>
  </v-menu>
</template>
<script>
export default {
  name: 'Tooltips',
  props: {
    width: Number,
    iconClass: [String, Object, Array],
  },
  data () {
    return {
      isPc: window.isPc
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Tooltips.vue